import React from "react";
import { Box, Typography, Sheet } from "@mui/joy";
import logo from "../images/yeti-clean-logo.png";
import { InlineWidget } from "react-calendly";

export default function Loom() {
    return (
        <Box
            sx={{
                minHeight: '100vh',
                background: 'linear-gradient(180deg, #f8fafc 0%, #e2e8f0 100%)',
                pb: { xs: 4, md: 6 }
            }}
        >
            {/* Header */}
            <Box sx={{ pt: { xs: 2, md: 4 }, pb: { xs: 2, md: 3 }, textAlign: 'center', px: 2 }}>
                <Box
                    component="img"
                    src={logo}
                    alt="YetiClean Logo"
                    sx={{ width: { xs: '200px', md: '280px' } }}
                />
            </Box>

            {/* Main Content Container */}
            <Box
                sx={{
                    maxWidth: '900px',
                    mx: 'auto',
                    px: { xs: 1.5, md: 2 }
                }}
            >
                {/* Video Section */}
                <Sheet
                    variant="outlined"
                    sx={{
                        borderRadius: { xs: '12px', md: '16px' },
                        overflow: 'hidden',
                        boxShadow: '0 4px 24px rgba(17, 42, 116, 0.12)',
                        border: '1px solid rgba(17, 42, 116, 0.1)'
                    }}
                >
                    <Box
                        sx={{
                            position: 'relative',
                            width: '100%',
                            paddingTop: '56.25%', // 16:9 aspect ratio
                            backgroundColor: '#000'
                        }}
                    >
                        <iframe
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                border: 'none'
                            }}
                            src="https://www.youtube.com/embed/boqqXWDlTAY"
                            title="YetiClean Video"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        />
                    </Box>
                </Sheet>

                {/* Booking Section */}
                <Box sx={{ mt: { xs: 3, md: 5 }, textAlign: 'center' }}>
                    <Typography
                        level="h3"
                        sx={{
                            color: '#112A74',
                            fontWeight: 600,
                            mb: { xs: 2, md: 3 },
                            fontSize: { xs: '1.25rem', md: '1.5rem' },
                            px: { xs: 1, md: 0 }
                        }}
                    >
                        Book a call with Mike to discuss your franchise opportunity
                    </Typography>

                    <Sheet
                        variant="outlined"
                        sx={{
                            borderRadius: { xs: '12px', md: '16px' },
                            overflow: 'visible',
                            boxShadow: '0 4px 24px rgba(17, 42, 116, 0.08)',
                            border: '1px solid rgba(17, 42, 116, 0.1)',
                            backgroundColor: '#fff'
                        }}
                    >
                        <InlineWidget
                            url="https://calendly.com/mikesmithlime/schedule-a-call"
                            styles={{ minWidth: '280px', height: '1000px' }}
                        />
                    </Sheet>
                </Box>

                {/* Footer */}
                <Box sx={{ mt: { xs: 3, md: 4 }, textAlign: 'center', px: 1 }}>
                    <Typography level="body-sm" sx={{ color: '#94a3b8', fontSize: { xs: '0.8rem', md: '0.875rem' } }}>
                        Questions? Contact us at{' '}
                        <Typography
                            component="a"
                            href="mailto:mike@mikesmithfranchising.co.uk"
                            sx={{ color: '#112A74', textDecoration: 'none', fontWeight: 500 }}
                        >
                            mike@mikesmithfranchising.co.uk
                        </Typography>
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
}

